import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { User, Award, Phone, Mail } from "lucide-react";

const TABS = [
  { key: "all", label: "Everyone" },
  { key: "coach", label: "Coaches" },
  { key: "administration", label: "Administration" },
  { key: "support", label: "Support" },
];

export default function Team() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("all");

  useEffect(() => {
    const params = tab === "all" ? {} : { category: tab };
    api.get("/team", { params }).then((r) => setItems(r.data));
  }, [tab]);

  return (
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-16" data-testid="team-page">
      <div className="font-mono text-xs uppercase tracking-[0.3em] brand-orange mb-4">// About HTP Sports Hub</div>
      <h1 className="font-display text-5xl md:text-7xl font-black uppercase leading-none tracking-tighter">
        The people <br /><span className="brand-blue">behind the game</span>.
      </h1>

      <div className="mt-10 flex gap-2 flex-wrap">
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            data-testid={`team-tab-${t.key}`}
            className={`px-4 py-2 font-mono text-xs uppercase tracking-widest border transition-all ${
              tab === t.key ? "bg-brand-blue text-white border-brand-blue" : "border-white/20 text-white/70 hover:border-white/50"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((m) => (
          <div key={m.id} data-testid={`team-card-${m.id}`} className="group border border-white/12 bg-[#131A2B] p-6 hover-lift">
            <div className="flex gap-4 items-start">
              {m.photo_url ? (
                <img src={m.photo_url} alt={m.name} className="w-20 h-20 rounded-full object-cover border border-white/12" />
              ) : (
                <div className="w-20 h-20 rounded-full bg-white/6 border border-white/12 flex items-center justify-center"><User size={26} className="text-white/40" /></div>
              )}
              <div className="flex-1 min-w-0">
                <div className="font-display text-xl uppercase font-bold leading-tight">{m.name}</div>
                <div className="text-xs font-mono brand-orange uppercase tracking-widest mt-1">{m.role}</div>
                {m.sport && <div className="text-[10px] font-mono text-white/40 mt-1 flex items-center gap-1"><Award size={10} /> {m.sport} · {m.experience_years}y</div>}
              </div>
            </div>
            {m.bio && <p className="text-sm text-white/60 mt-4 leading-relaxed">{m.bio}</p>}
            {(m.phone || m.email) && (
              <div className="mt-4 pt-4 border-t border-white/12 space-y-1 text-xs font-mono">
                {m.phone && <a href={`tel:${m.phone}`} className="flex items-center gap-2 text-white/60 hover:brand-blue"><Phone size={10} /> {m.phone}</a>}
                {m.email && <a href={`mailto:${m.email}`} className="flex items-center gap-2 text-white/60 hover:brand-blue"><Mail size={10} /> {m.email}</a>}
              </div>
            )}
          </div>
        ))}
        {items.length === 0 && <div className="col-span-full text-center py-16 text-white/40">No team members in this category.</div>}
      </div>
    </div>
  );
}
